import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { Button } from "@vitalsource/vstui";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import { Translation } from "../../../../core/translate";
import { cloud } from "@vitalsource/vstui/colors";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import { selectors as bridgeSelectors } from "../../../../../redux/bridge";
import TrendingIcon from "./trending-icon";
import BookButton from "./book-button";

const Styled = {
  Container: styled.div`
    align-items: center;
    background: white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    color: ${props => props.theme.color.base.getShade(7)};
    display: flex;
    flex-direction: column;
    height: 398px;
    justify-content: center;
    margin-bottom: 40px;
    width: 100%;
    ${styledMedia.small`
    height: 298px;
    margin-bottom: 30px;
  `}
  `,
  Content: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: visible;
  `,
  Details: styled.div`
    width: 443px;
  `,
  TrendingText: styled.div`
    font-size: 4rem;
    font-weight: 500;
    margin: 14px 0 16px;
    ${styledMedia.small`
    font-size: 2.6rem;
  `}
  `,
  TrendingSubtext: styled.div`
    color: ${cloud.getShade(9)};
    font-size: 1.6rem;
    font-weight: 400;
    margin-bottom: 23px;
  `,
  Covers: styled.div`
    display: flex;
    height: 270px;
    margin-right: 66px;
    position: relative;
    width: 549px;
  `,
  CenterCover: styled.div`
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  `,
  LeftCover: styled.div`
    left: 0;
    margin-left: 20px;
    position: absolute;
    transform: translate(0, -50%);
    top: 50%;
    z-index: 0;
  `,
  RightCover: styled.div`
    top: 50%;
    margin-right: 20px;
    position: absolute;
    right: 0;
    transform: translate(0, -50%);
    z-index: 0;
  `
};

class TrendingFeature extends React.Component {
  render() {
    const {
      subscriptionName,
      popular,
      onViewAll,
      openBookPanel,
      isMedium,
      promotionName
    } = this.props;

    if (!isMedium && (!popular || popular.length === 0)) {
      return null;
    }

    return (
      <Styled.Container>
        <Styled.Content>
          {!isMedium && (
            <Styled.Covers>
              <Styled.LeftCover>
                {popular[1] && (
                  <BookButton
                    width="171px"
                    height="222px"
                    asset={popular[1]}
                    onClick={openBookPanel}
                    forceHeight={false}
                    blur={true}
                  />
                )}
              </Styled.LeftCover>
              <Styled.CenterCover>
                {popular[0] && (
                  <BookButton
                    width="207px"
                    height="270px"
                    asset={popular[0]}
                    onClick={openBookPanel}
                    forceHeight={false}
                    blur={true}
                  />
                )}
              </Styled.CenterCover>
              <Styled.RightCover>
                {popular[2] && (
                  <BookButton
                    width="171px"
                    height="222px"
                    asset={popular[2]}
                    onClick={openBookPanel}
                    forceHeight={false}
                    blur={true}
                  />
                )}
              </Styled.RightCover>
            </Styled.Covers>
          )}
          <Styled.Details>
            <TrendingIcon />
            <Styled.TrendingText>
              <Translation
                id="explore.see-trending"
                subscriptionName={subscriptionName || promotionName}
              />
            </Styled.TrendingText>
            <Styled.TrendingSubtext>
              <Translation id="explore.top-titles" />
            </Styled.TrendingSubtext>
            <Button onClick={onViewAll} size="large">
              <Translation id="explore.view-all">View All</Translation>
            </Button>
          </Styled.Details>
        </Styled.Content>
      </Styled.Container>
    );
  }
}

const mapStateToProps = (state, props) => ({
  subscriptionName: bridgeSelectors.getSubscriptionName(
    state,
    props.subscriptionVbid
  ),
  promotionName: bridgeSelectors.getPromotionName(state, props.subscriptionVbid)
});

const mapDispatchToProps = dispatch => ({
  openBookPanel: asset =>
    dispatch(uiLibraryActions.openSimpleBookPanel(asset.vbid, asset.title))
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(TrendingFeature)
);
